enum SWAP_WAY {
  FROM = 'from',
  TO = 'to',
}

export default SWAP_WAY;
